import { defineComponent as _defineComponent } from 'vue'
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { LoadingIcon } from 'ah-common-lib/src/icons/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'AmountDisplay',
  props: {
    currency: null,
    loading: { type: [Boolean, String] },
    label: null,
    value: null
  },
  setup(__props: any) {



return { __sfc: true,formatCurrencyValue, LoadingIcon }
}

})